/**
 * AI 队友对话接口。
 * 契约：POST /assistant/chat → {reply, via, contextUsed}
 * 历史由客户端保存；via 标注 'llm'（大模型）/ 'rule'（规则回退）。
 */
import { api } from './client.js';
import type { AssistantChatDto, AssistantChatPayload } from './types.js';

export const assistantApi = {
  chat: (payload: AssistantChatPayload): Promise<AssistantChatDto> => api.post<AssistantChatDto>('/assistant/chat', payload),
};
